import React from 'react';

const Badge = ({ count }) => {
  if (!count || count === 0) return null;
  
  return (
    <span className="badge">
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default Badge;
